import { Button, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger } from "@chakra-ui/react";
import React from "react";
import { getLocalisedTime } from "../../../Library/datetime";
import "./style.css";

const PopoverCard = ({ data, cardTitle, array, removePopover, dateTime }) => {
  return (
    <Popover onClose={removePopover} placement="left">
      <PopoverTrigger>
        <Button
          onClick={() => removePopover(true)}
          className="popover-trigger"
        >
          {data}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="popover-content">
        <PopoverArrow className="popover-arrow" />
        <PopoverCloseButton />
        <p className="popover-heading">{cardTitle}</p>
        <PopoverBody className="popover-body">
          {(dateTime ? array.sort((ts1, ts2) => ts2 - ts1) : array).map((value, idx) => {
            if(value) return (
              <div key={idx} className="popover-card-rows">
                {/* <p className="threshold-ts-count">{idx + 1})</p> */}
                {!dateTime ? value : (`${idx + 1}) ${new Date(value).toLocaleDateString("en-GB")}`)}
              </div>
            )
          })}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default PopoverCard;
